"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _personAvatar = _interopRequireDefault(require("@atlaskit/icon/core/person-avatar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UserAvatarCircleIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
}, props, {
  newIcon: _personAvatar.default
}));
UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var _default = exports.default = UserAvatarCircleIcon;